/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'

import { PropTypes } from 'prop-types'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Dialog } from 'primereact/dialog'
import { userActions } from '../_actions'

function SubBrandComponent({ brandList, bulkUpdate, parentCompanyId, deleteCompany, bulkUpdateSuccessMessage, showGrowlMessage, bulkUpdatesubBrand, clearAllMessages, isAddCompany, updateSubBrand }) {

  const [companyData, setCompanyData] = useState([])
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false)
  const [deleteRow, setDeleteRow] = useState(false)
  const [updatedRows, setUpdatedRows] = useState((companyData && companyData.filter(f => f.isUpdated === true)).length > 0)

  const setCompanyDataProcess = () => {
    const companyArray = []
    if (brandList && brandList.length > 0) {
      for (let i = 0; i < brandList.length; i++) {
        const company = brandList[i]
        companyArray.push({
          'id': company.companyId,
          'name': company.name,
          'marketCapitalization': company.marketCapitalization,
          'logoPath': company.logoPath,
          'encodedImageString': company.encodedImageString,
          'updatedBy': userActions.getCurrentUser(),
          parentCompanyId: company.parentCompanyId,
          'companyId': company.companyId,
          'createdBy': company.createdBy
        })
      }
    }
    setCompanyData(companyArray)
  }

  useEffect(() => {
    setCompanyDataProcess()
    setUpdatedRows(false)
    if (bulkUpdateSuccessMessage === 'success') {
      showGrowlMessage('Saved Successfully')
      clearAllMessages()
    }
  }, [brandList])

  const inputTextEditor = (props, field) => {
    if (field === 'logoPath') {
      return <InputText type="text" value={props.rowData[field]} onChange={(e) => onEditorValueChange(props, e.target.value)} />
    } else
      return <InputText type="text" maxlength="250" value={props.rowData[field]} onChange={(e) => onEditorValueChange(props, e.target.value)} />
  }

  const textBoxEditor = (props) => {
    return inputTextEditor(props, props.field)
  }

  const requiredValidator = (props) => {
    const value = props.rowData[props.field]
    return value && value.length > 0
  }

  const cancelEdit = () => {
    setCompanyDataProcess()
    setUpdatedRows(false)
  }

  const addRow = () => {
    const tempcompanyData = [...companyData]
    tempcompanyData.push({
      'name': '',
      'logoPath': '',
      'createdBy': userActions.getCurrentUser(),
      'parentCompanyId': parentCompanyId
    })
    setCompanyData(tempcompanyData)
  }

  const updateCompany = (event) => {
    let companyArray = []
    const updateArray = []
    companyArray = companyData.filter(f => f.isUpdated === true)

    companyArray && companyArray.map(company => {
      const companyfiltered = brandList.filter(a => a.companyId === parseInt(company.id))
      if (companyfiltered == null || companyfiltered.length <= 0) {
        company.parentCompanyId = parentCompanyId
        updateArray.push(company)
      } else {
        companyfiltered[0].name = company.name
        companyfiltered[0].marketCapitalization = company.marketCapitalization
        companyfiltered[0].logoPath = company.logoPath
        companyfiltered[0].updatedBy = company.updatedBy
        updateArray.push(companyfiltered[0])
      }
      return company
    })
    if (updateArray && updateArray.length > 0) {
      bulkUpdatesubBrand(updateArray)
    }
  }

  const onEditorValueChange = (props, value) => {
    const updatedCompany = [...props.value]
    updatedCompany[props.rowIndex][props.field] = value
    updatedCompany[props.rowIndex]['isUpdated'] = true
    if(props.field === 'logoPath')
       updatedCompany[props.rowIndex]['encodedImageString'] =  value.includes('data:image/jpeg;base64,') ? value.replace('data:image/jpeg;base64,', '') : null
    setCompanyData(updatedCompany)
    setUpdatedRows(true)
    if (isAddCompany)
      updateSubBrand(companyData)
  }

  const logoTemplate = (rowData, column) => {

    return rowData.logoPath && rowData.logoPath.trim().length > 0 && ((rowData.logoPath.includes('https:')||rowData.logoPath.includes('http:')) ?   <div className="flexCenterCenter">
        <img alt="Company Logo" src={`${rowData.logoPath}`} style={{ width: '31px' }}></img>
      </div>:
      <div className="flexCenterCenter">
      <img alt="Company Logo" src={`data:image/jpeg;base64,${rowData.encodedImageString}`} style={{ width: '20px' }}></img>
    </div>)
  }

  const showDeleteDialog = (event, rowData) => {
    setDeleteRow(rowData)
    setIsDeleteDialogVisible(true)
  }

  const actionTemplate = (event, rowData) => {
    if (rowData.rowData.hasOwnProperty('id')) {
      return <div className="flexCenterCenter">
        <i className="pi pi-trash pointer" onClick={(event) => showDeleteDialog(event, rowData)}></i>
      </div>
    }

  }

  const deleteCompanyById = () => {
    if (deleteRow.rowData.id) {
      deleteCompany(deleteRow.rowData.id, userActions.getCurrentUser())
      if (isAddCompany) {
        companyData.splice(deleteRow.rowIndex, 1)
        updateSubBrand(companyData)
        setUpdatedRows(false)
      }
    } else {
      companyData.splice(deleteRow.rowIndex, 1)
      updateSubBrand(companyData)
      setUpdatedRows(false)
    }

    setIsDeleteDialogVisible(false)
  }

  const footer = (
    <div>
      <Button label="OK" icon="pi pi-check" onClick={() => deleteCompanyById()} />
      <Button label="Cancel" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsDeleteDialogVisible(false)} />
    </div>
  )

  return (
    <div className={isAddCompany ? companyData?.length === 0 ? "customSubBrandSecwhdn" : "customSubBrandSecwh" : "customSubBrandSec"}>
      <div className="p-grid p-justify-end w-20">
        <div className="customBtnContainer m-t-10 m-b-10">
        </div>
      </div>
      <div className="p-grid ">
        <DataTable className="customBrandCon" value={companyData} dataKey="id" emptyMessage='No Sub Brands Found' responsive={true} style={{ marginTop: '20px', width: isAddCompany ? '100%' : '20%' }}>
          <Column editor={textBoxEditor} editorValidator={requiredValidator} key="logoPath" body={logoTemplate} field="logoPath" style={{ textAlign: 'left', width: '80px' }} header="SUB BRAND LOGO" />
          <Column editor={textBoxEditor} editorValidator={requiredValidator} key="name" field="name" style={{ textAlign: 'left', width: '100px' }} header="SUB BRAND NAME" />
          <Column key={'action'} body={actionTemplate} style={{ textAlign: 'center', width: '60px', height: '52px' }} header="ACTION" />
        </DataTable>
      </div>
      {!isAddCompany && <div className="p-grid p-justify-end w-20">
        <div className="customBtnContainer m-t-10 m-b-10">
          <Button icon="pi pi-plus" className="addBtnCustom" onClick={() => addRow()} >Add</Button>
        </div>
        {updatedRows &&
          <div className='subBrandActionFlex'>
            <div className="customBtnContainer m-t-10 m-b-10 m-l-10">
              <Button icon="pi pi-refresh" className="addBtnCustom" onClick={() => cancelEdit()} >Clear</Button>
            </div>
            <div className="customBtnContainer m-t-10 m-b-10 m-l-10">
              <Button icon="pi pi-save" className="addBtnCustom" onClick={updateCompany} >Save</Button>
            </div>
          </div>
        }

      </div>}
      <Dialog header="Delete Sub Brand" footer={footer} visible={isDeleteDialogVisible} style={{ width: '50vw' }} modal={true} onHide={() => setIsDeleteDialogVisible(false)}>
        <div>Are you sure you want to delete this sub brand?</div>
      </Dialog>
    </div>
  )
}

SubBrandComponent.propTypes = {
  brandList: PropTypes.array,
  bulkUpdate: PropTypes.func,
  parentCompanyId: PropTypes.number,
  deleteCompany: PropTypes.func,
  bulkUpdateSuccessMessage: PropTypes.string,
  showGrowlMessage: PropTypes.func,
  bulkUpdatesubBrand: PropTypes.func,
  isAddCompany: PropTypes.bool
}
export default SubBrandComponent
